import React from 'react';
import ReactCrop from 'react-image-crop';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { CustomRodal } from '@lua-frontend/numu-ui';
import 'react-image-crop/dist/ReactCrop.css';

const ModalBody = styled.div`
  display: flex;
  flex-direction: column;

  .buttons {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    gap: 12px;
    button {
      height: 35px;
      width: 125px;
      font-size: 14px;
      border: none;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Montserrat SemiBold';
      transition: all 0.2s ease;
    }
    .btn-cancel {
      background-color: var(--grey-5, #f5f5f5);
      color: var(--blue-50, #007bff);
      &:hover {
        background-color: var(--grey-10, #e8e8e8);
      }
    }
    .btn-crop {
      background-color: var(--blue-50, #007bff);
      color: white;
      font-weight: bold;
      &:hover {
        background-color: var(--blue-60, #0056b3);
      }
      &:disabled {
        background-color: var(--grey-5, #f5f5f5);
        color: var(--grey-20, #999);
        cursor: not-allowed;
        opacity: 0.6;
      }
    }
  }
`;

const CropImage = styled.div`
  width: 100%;
  overflow: hidden;
  margin: auto;
  display: flex;
  justify-content: center;
  .ReactCrop {
    width: auto;
    height: 100%;
    div {
      height: 100%;
      width: auto;
      img {
        object-fit: contain;
        max-height: 400px;
        min-width: 100px;
        width: unset;
        height: unset;
      }
    }
  }
`;

const ImageCropModal = ({ crop, isUploading, onClose, onConfirm }) => {
  if (!crop || !crop.isOpen) {
    return null;
  }

  return (
    <CustomRodal
      visible={crop.isOpen}
      onClose={onClose}
      style={{
        borderRadius: '10px',
        maxHeight: '570px',
        height: 'fit-content',
        width: '40%',
        zIndex: 1000000
      }}
      header={<FormattedMessage id="crop.header" defaultMessage="Crop Image" />}
    >
      <ModalBody>
        <CropImage>
          <ReactCrop
            src={crop.src}
            onImageLoaded={crop.onImageLoaded}
            crop={crop.rect}
            onChange={crop.onChange}
            onComplete={crop.makePreview}
          />
        </CropImage>
        <div className="buttons">
          <button className="btn-cancel" type="button" onClick={onClose}>
            <FormattedMessage id="decline.cancel" defaultMessage="Cancel" />
          </button>
          <button className="btn-crop" type="button" onClick={onConfirm} disabled={isUploading}>
            {isUploading ? (
              <FormattedMessage id="upload.uploading" defaultMessage="Uploading..." />
            ) : (
              <FormattedMessage id="button.crop" defaultMessage="Crop" />
            )}
          </button>
        </div>
      </ModalBody>
    </CustomRodal>
  );
};

export default ImageCropModal;
